import { useState, useEffect, memo } from 'react'
import QRCode from 'qrcode.react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

const Label = styled.div`
  font-size: 10px;
  line-height: 140%;
  font-weight: bold;
  color: var(--color-brand-red);
  margin-right: 10px;
  padding-top: 5px;
`

const getQRCodeSize = () => (window.innerWidth <= 700 ? 20 : 28)

const Right = ({ qrCodeValue }) => {
  const { t } = useTranslation()

  const [qrCodeSize, setQrCodeSize] = useState(() => getQRCodeSize())
  useEffect(() => {
    const onSizeChanged = () => setQrCodeSize(getQRCodeSize())
    window.addEventListener('resize', onSizeChanged)
    return () => window.removeEventListener('resize', onSizeChanged)
  }, [])

  return (
    <Wrapper>
      <Label>{t('wine.techlist.footer.qrCodeDesc')}</Label>
      <QRCode value={qrCodeValue} size={qrCodeSize} />
    </Wrapper>
  )
}

export default memo(Right)
